import { computed, inject } from 'vue';
import { get } from 'lodash';
import { useRoute } from 'vue-router';
import { useFormContext } from '/app/composables/form';

export const useHideable = (slug, { isOpen } = {}) => {
    const form = useFormContext();
    const builder = inject('builder', null);
    const route = useRoute();

    const rules = computed(() => {
        const platformCategory = get(form, 'fields.challenge.platform_category');

        return {
            'innovation-scale': [
                () => true,
                () => builder?.isCaption,
            ],
            'duration': [
                () => true,
            ],
            'money-prizes': [
                () => true,
            ],
            'assumptions': [
                () => true,
                () => builder?.isCaption,
                () => (platformCategory || '').includes('comedy-'),
            ],
            'question-description': [
                () => !builder?.usingTool('qq') && builder?.isCaption,
            ],
            'your-idea': [
                () => route.name !== 'challenges.test-idea',
                () => builder?.isCaption,
            ],
            'article-source': [
                () => builder?.isCaption,
                () => (platformCategory || '').includes('comedy-'),
            ],
            'caption-format': [
                () => !builder?.isCaption,
            ],
        };
    });

    const isHidden = (targetSlug) => {
        const openVal = isOpen ? isOpen.value : false;
        return !openVal && rules.value[targetSlug] && rules.value[targetSlug].some(rule => rule());
    };

    const hidden = computed(() => isHidden(slug));

    return {
        rules,
        hidden,
        isHidden,
    };
};
